import { CAlert } from "@coreui/react";
import { Link, useLocation } from "react-router-dom";

const DashboardDocumentFilterNotice = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const documentId = params.get("document_id");
  const metric = params.get("dashboard_metric");
  if (!documentId && !metric) return null;

  return (
    <CAlert color="info">
      {documentId
        ? `Mostrando el documento #${documentId}. `
        : metric === "errors"
          ? "Mostrando los documentos emitidos este mes con errores. "
          : "Mostrando los documentos emitidos este mes pendientes de procesamiento. "}
      <Link to={location.pathname}>Ver la lista completa</Link>
    </CAlert>
  );
};

export default DashboardDocumentFilterNotice;
